import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import React, { FC } from 'react';

interface GmailActionProps {
  emailAddress: string;
}
const GmailAction: FC<GmailActionProps> = ({ emailAddress }) => {
  const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    emailAddress
  )}`;
  return (
    <a
      href={gmailUrl}
      target="_blank"
      rel="noreferrer"
      className="rounded-full "
      title="Enviar Gmail"
      style={{
        backgroundColor: '#EA4335',
        color: '#ffffff',
        width: '19px',
        height: '19px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #EA4335'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = '#EA4335';
        e.currentTarget.style.borderColor = '#ffffff';
        e.currentTarget.style.backgroundColor = '#ffffff';
        e.currentTarget.style.border = '1px solid #EA4335';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = '#ffffff';
        e.currentTarget.style.borderColor = '#ffffff';
        e.currentTarget.style.backgroundColor = '#EA4335';
        e.currentTarget.style.border = '1px solid #EA4335';
      }}
    >
      <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: '13px' }} />
    </a>
  );
};

export default GmailAction;
